import React, { useState } from 'react'
import HeaderComponent from '../components/HeaderComponent'
import DialogRecommendation from './DialogRecommendation'
import DialogBusiness from './DialogBusiness'

const Header = ({ pageProps }) => {
  const [dialogRecommendation, setDialogRecommendation] = useState({
    isOpen: false,
    data: null,
  })
  const [dialogBusiness, setDialogBusiness] = useState({
    isOpen: false,
    data: null,
  })

  return (
    <>
      <HeaderComponent
        title={pageProps.header}
        description={<span>{pageProps.description}</span>}
        description2={<span>{pageProps.description2}</span>}
        setDialogRecommendation={setDialogRecommendation}
        setDialogBusiness={setDialogBusiness}
      />
      <DialogRecommendation
        dialog={dialogRecommendation}
        setDialog={setDialogRecommendation}
      />
      <DialogBusiness dialog={dialogBusiness} setDialog={setDialogBusiness} />
    </>
  )
}

export default Header
